import { debounce } from 'js-utils/src/function';

import init from '../../common/base/init';

// stickyness

init(() => {
  const bar = document.querySelector('.nav-bar');
  if(!bar) return;

  let distance = bar.offsetTop - window.pageYOffset;

  window.addEventListener('scroll', () => {
    distance = bar.offsetTop - window.pageYOffset;
    bar.classList.toggle(
      '--fixed',
      distance <= 0 && !document.body.classList.contains('shepherd-active'),
    );
  });
});

// toggler visibility

init(() => {
  const nav = document.querySelector('.nav-bar .hnav');
  const toggle = document.querySelector('.nav-bar .-toggle');
  if(!nav || !toggle) return;

  const toggleVisibility = () => {
    const hide = nav.scrollWidth <= nav.offsetWidth;
    toggle.classList.toggle('is-hidden', hide);
  };

  window.addEventListener('resize', debounce(300, toggleVisibility));
  toggleVisibility();
});
